import { loadStripe } from '@stripe/stripe-js';

const publishableKey =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  process.env.REACT_APP_STRIPE_PUBLIC_KEY;

if (!publishableKey) {
  // eslint-disable-next-line no-console
  console.error('[stripe] REACT_APP_STRIPE_PUBLISHABLE_KEY is not set.');
}

const stripePromise = loadStripe(publishableKey);
export default stripePromise;